import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tickets: [],
  isLoading: false,
  error: "",
  searchedTickets: [],
  selectedTicket: {},
};

const ticketSlice = createSlice({
  name: "ticketList",
  initialState,
  reducers: {
    fetchTicketLoading: (state) => {
      state.isLoading = true;
    },
    fetchTicketSuccess: (state, action) => {
      state.tickets = action.payload;
      state.searchedTickets = action.payload;
      state.isLoading = false;
    },
    fetchTicketFail: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },
    fetchSearchTickets: (state, { payload }) => {
      state.searchedTickets = state.tickets.filter((row) => {
        return row.subject.toLowerCase().includes(payload.toLowerCase());
      });
    },
    selectTicketProcessing: (state) => {
      state.isLoading = true;
    },
    selectedTicketSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.selectedTicket = payload;
      state.error = "";
    },
    selectedTicketFail: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },
    replyLoading: (state) => {
      state.isLoading = true;
    },
    replySuccess: (state) => {
      state.isLoading = false;
      state.error = "";
    },
    replyFail: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },
  },
});

const { reducer, actions } = ticketSlice;
export const {
  fetchTicketLoading,
  fetchTicketSuccess,
  fetchTicketFail,
  fetchSearchTickets,
  selectedTicketFail,
  selectedTicketSuccess,
  selectTicketProcessing,
  replyLoading,
  replySuccess,
  replyFail,
} = actions;

export default reducer;
